/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  map of all rent reports
 */

export const RENT_REPORT_CITY_STATES = [
  'atlanta-ga',
  'austin-tx',
  'boston-ma',
  'charlotte-nc',
  'chicago-il',
  'dallas-tx',
  'detroit-mi',
  'denver-co',
  'houston-tx',
  'kansas-city-mo',
  'las-vegas-nv',
  'los-angeles-ca',
  'miami-fl',
  'minneapolis-mn',
  'nashville-tn',
  'new-york-ny',
  'norfolk-va',
  'orlando-fl',
  'philadelphia-pa',
  'phoenix-az',
  'portland-or',
  'sacramento-ca',
  'salt-lake-city-ut',
  'san-diego-ca',
  'san-francisco-ca',
  'seattle-wa',
  'tampa-fl',
  'washington-dc',
] as const
